import {DeleteIconButton} from '@/components/basic/buttons';
import AutocompleteArrayInput from '@/components/refinedev/AutocompleteArrayInput';
import {useCan} from '@refinedev/core';
// import SelectInput from '@/components/refinedev/SelectInput';

export const ConversationMemberArrayInput = ({
  source,
  reference,
}: {
  source?: string;
  reference?: string;
}) => {
  const {data: canAccessUsers} = useCan({resource: 'users', action: 'list'});
  if (canAccessUsers?.can === false) return null;

  return (
    <AutocompleteArrayInput
      source={source || 'members'}
      reference={reference || 'staffs'}
      label={'Thành viên nhóm trao đổi'}
      placeholder="Chọn người tham gia"
      autoCompleteProps={{optionText: 'name'}}
      // buildFilter={(text: string) => [
      //   {
      //     field: 'staff_name',
      //     operator: 'contains',
      //     value: text,
      //   },
      // ]}
      renderSelectedItemsFirst
      renderSelectedItems={(items, removeAt) => {
        if (items.length === 0) return null;
        return (
          <table className="min-w-full divide-y divide-gray-200 mt-2">
            <thead className="bg-gray-100 py-2">
              <tr>
                <th
                  scope="col"
                  className="px-2 text-left text-xs font-medium text-gray-800 uppercase tracking-wider">
                  STT
                </th>
                <th
                  scope="col"
                  className="px-2 text-left text-xs font-medium text-gray-800 uppercase tracking-wider">
                  Tên
                </th>
                {/* <th
                  scope="col"
                  className="px-2 text-left text-xs font-medium text-gray-800 uppercase tracking-wider">
                  Vai trò
                </th> */}
                <th
                  scope="col"
                  className="px-2 text-left text-xs font-medium text-gray-800 uppercase tracking-wider">
                  Hành động
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {items.map((item, index) => (
                <tr key={item.id} className="hover:bg-gray-50">
                  <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-800">{index + 1}</td>
                  <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-800">{item.name}</td>
                  {/* <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-800">
                    <SelectInput source={`members.${index}.pivot.role`} choices={TaskMemberTypes} />
                  </td> */}
                  <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-800">
                    <DeleteIconButton
                      onClick={e => {
                        removeAt(index);
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      }}
    />
  );
};
